/**
 * About Us — nudge the fixed "Book a Consultation" bar when scrolling stops.
 *
 * Loaded only on the About Us page (see layout/theme.liquid) and only acts at
 * phone widths, so nothing else on the site is affected.
 *
 * The guards matter more than the animation. A bar that bobs every time a
 * thumb pauses is irritating and quickly becomes invisible, so a nudge needs
 * all of these to be true:
 *
 *   - scrolling has actually stopped (not just slowed) for IDLE_MS
 *   - the reader has travelled MIN_TRAVEL since the last nudge, so re-reading
 *     the same paragraph never triggers it
 *   - COOLDOWN_MS has passed, which caps it at roughly once per section
 *   - they are past MIN_FROM_TOP, so it never fires on arrival
 *   - the button is not `inert` — the snippet's own script sets that while the
 *     bar is hidden or still running its intro fade
 *
 * Tune the four numbers below; everything else follows from them.
 */
(function () {
  var IDLE_MS = 650; // how long a pause counts as "stopped"
  var MIN_TRAVEL = 400; // px scrolled since the last nudge
  var COOLDOWN_MS = 9000; // never more often than this
  var MIN_FROM_TOP = 200; // px from the top before the first nudge

  var container = document.getElementById('fixed-button-container');
  var button = document.getElementById('fixed-button');
  if (!container || !button) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var phone = window.matchMedia('(max-width: 749px)');

  var timer = null;
  var lastNudgeY = window.scrollY;
  var lastNudgeAt = 0;

  function eligible() {
    if (reduce.matches) return false;
    if (!phone.matches) return false;
    if (button.hasAttribute('inert')) return false;
    if (window.scrollY < MIN_FROM_TOP) return false;
    if (Math.abs(window.scrollY - lastNudgeY) < MIN_TRAVEL) return false;
    if (Date.now() - lastNudgeAt < COOLDOWN_MS) return false;
    return true;
  }

  function nudge() {
    if (!eligible()) return;
    lastNudgeY = window.scrollY;
    lastNudgeAt = Date.now();
    container.classList.add('fixed-button--nudge');
  }

  container.addEventListener('animationend', function (event) {
    if (event.animationName === 'fixedButtonNudge') {
      container.classList.remove('fixed-button--nudge');
    }
  });

  window.addEventListener(
    'scroll',
    function () {
      // Never let it bob while the page is still moving.
      container.classList.remove('fixed-button--nudge');
      clearTimeout(timer);
      timer = setTimeout(nudge, IDLE_MS);
    },
    { passive: true }
  );
})();
